import React from 'react';

const TagsLayout = (props) => (
  <div className={`tags-layout ${props.aditionalClass ? props.aditionalClass : ''}`}>{props.children}</div>
);

export default TagsLayout;
